import React from "react";

import { Button } from "../../../atoms/Buttons/Base";
import { Text } from "../../../atoms/Text/Text";
import { User } from "../../../models/User";
import { MaxCounter } from "../FriendBlockUserAuthorized";
import FriendApiService from "../../../services/Friend/FriendApiService";
import FriendService from "../../../services/Friend/FriendService";
import { FriendPopupType } from "../../../models/Enums";
import styles from "./SendInvitePopup.css";
import classNames from "classnames";

type SendInvitePopupProps = {
  user: User;
  friendCount?: number;
  popupType: FriendPopupType;
  onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onLoadContent: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
};

export class SendInvitePopup extends React.Component<SendInvitePopupProps> {
  static displayName = "Send Invite";
  state = {
    inviteLink: "",
    isCopy: false,
  };

  async loadInviteLink(): Promise<void> {
    const guid = await FriendApiService.getInviteGuid();
    this.setState({ inviteLink: FriendService.getLinkToInvite(guid) });
  }

  async componentDidMount(): Promise<void> {
    if (this.props.popupType === "sendInvite") {
      await this.loadInviteLink();
    }
    this.props.onLoadContent(null);
  }

  copyToClipBoard = () => {
    navigator.clipboard.writeText(this.state.inviteLink);
    this.setState({ isCopy: true });
  };

  handlerSendInvite = (user: User, friendCount: number) => {
    if (this.props.popupType === "sendInvite") {
      return (
        <React.Fragment>
          <Text
            className={styles.coverHeaderInfo}
            bold={true}
            size="h3"
            align="center"
          >
            Hi, <span className={styles.userNameInvitor}>{user.name}.</span>
          </Text>

          <Text
            bold={true}
            size="lg"
            align="center"
            margin="16px 0 5px 0"
            className={styles.coverTitleInfo}
          >
            You can add up to 150 of your buddies to your Private Friends
            Network (PFN).
            <br />
            Just copy and paste the link below in email or text!
            <br />
            You can see who has accepted in the Friends tab of your PFN.
            <br />
            <br />
            {/* /////HARD CODE FOR TRIVIA  ONLY It is not game name*/}
            Have fun and see who has the top score in{" "}
            <i>Right Again! Trivia.</i>
            <br />
            <br />
            Your Friend Count is {friendCount}.
          </Text>

          <Button
            onClick={this.copyToClipBoard}
            className={styles.buttonFriend}
          >
            <Text bold={true} size="sm" style={{ padding: "5px" }}>
              Copy Invitation Link
            </Text>
          </Button>

          <Text
            size="md"
            className={classNames(styles.coverTitleInfo, {
              [styles.copySendInvite]: !this.state.isCopy,
            })}
          >
            Link copied. Send it to a friend!
          </Text>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Text
          bold={true}
          size="xl"
          className={styles.coverTitleInfo}
          align="center"
          margin="0 0 5px 0"
        >
          Thanks for participating in the Private Friends Network, which has a
          cap of {MaxCounter} friends. To manage your friends list, the Friends
          View can be especially useful with the alphabetical list of your
          buddies!
        </Text>

        <Button
          onClick={this.props.onClose}
          className={classNames(styles.buttonYesNoLong, styles.buttonFriend)}
        >
          <Text bold={true} size="sm" style={{ padding: "5px" }}>
            Got it
          </Text>
        </Button>
      </React.Fragment>
    );
  };

  render() {
    if (
      this.props.popupType === "sendInvite" &&
      !this.state.inviteLink.length
    ) {
      return null;
    }
    const { user, friendCount } = this.props;

    return this.handlerSendInvite(user, friendCount);
  }
}
